// src/socket.js
import { io } from "socket.io-client";

var SOCKET_URL;

if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  SOCKET_URL = "http://localhost:5001";
} else {
  // production code
  // SOCKET_URL = "http://localhost:5001"; // For testing on local server
  SOCKET_URL = `${window.location.protocol}//${window.location.hostname}`;
}

var socket;
let actualStand = false;

export const initializeSocket = (token) => {
  // if (!socket) {
  socket = io(SOCKET_URL, {
    auth: {
      token: token,
    },
  });

  // console.log("socket?.io?.opts :>> ", socket?.io?.opts); // Check status of connection

  // socket.on("connect", () => {
  //   actualStand = true;
  //   console.log("Socket connected:", socket.id);
  // });

  // socket.on("disconnect", (reason) => {
  //   actualStand = false;
  //   console.log("SOCKETTT");
  //   console.log("Socket disconnected:", reason);
  // });

  // Hier kannst du weitere Socket-Events hinzufügen, die global verwendet werden sollen
  // }

  return socket;
};

export const getSocket = () => {
  if (!socket) {
    throw new Error("Socket not initialized. Call initializeSocket first.");
  }
  return socket;
};

export const getSocketConnectionInfo = () => {
  if (socket) {
    // Rückgabe basierend auf tatsächlichem Verbindungsstatus
    return actualStand;
  } else {
    console.warn("Socket not initialized. Connection status is unavailable.");
    return false;
  }
};
